import { Table } from 'antd';
import Column from 'antd/es/table/Column';
import { useHistory } from 'react-router-dom';

import { dateTimeCell2 } from 'app/components/lists/cells';
import type { UserGiftCard } from 'app/typings';
import { sortDate } from 'app/utils/sort';
import { capitalizeFirstLetter } from 'app/utils/string';

import 'styles/pages/Users/user-details.scss';

import { ActionCellMenu } from '../../../lists/ActionCellMenu';

const STATUS_FILTER_VALUES = [
  {
    value: 'active',
    text: 'Active',
  },
  {
    value: 'empty',
    text: 'Empty',
  },
  {
    value: 'expired',
    text: 'Expired',
  },
  {
    value: 'cancelled',
    text: 'Cancelled',
  },
];

const sortGiftCardsByDateField = (valueA: UserGiftCard, valueB: UserGiftCard) =>
  sortDate(valueA.date, valueB.date, 'ascend');

type GiftCardsLinkedProps = {
  giftCards: UserGiftCard[];
};

export const GiftCardsLinked: React.FC<GiftCardsLinkedProps> = ({
  giftCards,
}: GiftCardsLinkedProps) => {
  const history = useHistory();

  const handleActionClick = ({ code }: UserGiftCard) => {
    history.push(`/gift-cards/${code}`);
  };

  const handleRowClick = ({ code }: UserGiftCard) => {
    return {
      onClick: () => history.push(`/gift-cards/${code}`),
    };
  };

  return (
    <div className="bloc" style={{ minWidth: '800px' }}>
      <div className="title">Gift cards</div>
      <Table
        dataSource={giftCards}
        pagination={false}
        rowKey="code"
        onRow={handleRowClick}
      >
        <Column key="code" className="strong" title="Code" dataIndex="code" />
        <Column
          key="date"
          title="Date"
          sorter={sortGiftCardsByDateField}
          defaultSortOrder="descend"
          render={dateTimeCell2}
          dataIndex="date"
        />
        <Column
          key="cardType"
          title="Type"
          dataIndex="cardType"
          render={(value: string) => capitalizeFirstLetter(value)}
        />
        <Column
          key="value"
          title="Amount"
          render={(_, giftCard: UserGiftCard) => (
            <div>
              {giftCard.valueType === 'FIX'
                ? `${giftCard.amount}€`
                : `${giftCard.discount}%`}
            </div>
          )}
          dataIndex="value"
        />
        <Column
          className="strong"
          title="Status"
          key="status"
          dataIndex="status"
          render={(value) => (
            <div>
              {STATUS_FILTER_VALUES.find((status) => status.value === value)
                ?.text ?? ''}
            </div>
          )}
        />
        <Column
          key="actions"
          className="actions-column"
          onCell={() => ({ onClick: (e) => e.stopPropagation() })}
          render={(entity) => (
            <ActionCellMenu
              entity={entity}
              handleActionClick={handleActionClick}
            />
          )}
        />
      </Table>
    </div>
  );
};
